// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, ServerSentEventsResult, TDataShape } from './client';
import { client } from './client.gen';
import type {
  CreateNewListingAlertSubscriptionData,
  CreateNewListingAlertSubscriptionErrors,
  CreateNewListingAlertSubscriptionResponses,
  CreateSubscriptionData,
  CreateSubscriptionErrors,
  CreateSubscriptionResponses,
  DeleteNewListingAlertSubscriptionData,
  DeleteNewListingAlertSubscriptionErrors,
  DeleteNewListingAlertSubscriptionResponses,
  GetAdUnitData,
  GetAdUnitErrors,
  GetAdUnitResponses,
  GetAdUnitToDisplayData,
  GetAdUnitToDisplayErrors,
  GetAdUnitToDisplayResponses,
  GetAlternateCategorySlugData,
  GetAlternateCategorySlugErrors,
  GetAlternateCategorySlugResponses,
  GetAlternateChildLocationSlugData,
  GetAlternateChildLocationSlugErrors,
  GetAlternateChildLocationSlugResponses,
  GetAlternateLocationSlugData,
  GetAlternateLocationSlugErrors,
  GetAlternateLocationSlugResponses,
  GetArticleAuthorData,
  GetArticleAuthorErrors,
  GetArticleAuthorResponses,
  GetArticleCategoryData,
  GetArticleCategoryErrors,
  GetArticleCategoryResponses,
  GetArticleData,
  GetArticleErrors,
  GetArticleResponses,
  GetArticlesData,
  GetArticlesErrors,
  GetArticlesResponses,
  GetBuilderArticlesData,
  GetBuilderArticlesErrors,
  GetBuilderArticlesResponses,
  GetBuilderData,
  GetBuilderErrors,
  GetBuilderProjectsData,
  GetBuilderProjectsErrors,
  GetBuilderProjectsResponses,
  GetBuilderResponses,
  GetBuildersData,
  GetBuildersErrors,
  GetBuildersResponses,
  GetCitiesData,
  GetCitiesErrors,
  GetCitiesResponses,
  GetCityData,
  GetCityErrors,
  GetCityResponses,
  GetCustomIconsData,
  GetCustomIconsErrors,
  GetCustomIconsResponses,
  GetDirectoryCategoriesData,
  GetDirectoryCategoriesErrors,
  GetDirectoryCategoriesResponses,
  GetEditorialArticlesData,
  GetEditorialArticlesErrors,
  GetEditorialArticlesResponses,
  GetEditorialBuilderLocationsData,
  GetEditorialBuilderLocationsErrors,
  GetEditorialBuilderLocationsResponses,
  GetEditorialCategoriesData,
  GetEditorialCategoriesErrors,
  GetEditorialCategoriesResponses,
  GetEditorialCategoryData,
  GetEditorialCategoryErrors,
  GetEditorialCategoryResponses,
  GetEditorialCategorySearchResultsData,
  GetEditorialCategorySearchResultsErrors,
  GetEditorialCategorySearchResultsResponses,
  GetEditorialChildLocationData,
  GetEditorialChildLocationErrors,
  GetEditorialChildLocationNearbySearchResultsData,
  GetEditorialChildLocationNearbySearchResultsErrors,
  GetEditorialChildLocationNearbySearchResultsResponses,
  GetEditorialChildLocationResponses,
  GetEditorialChildLocationsData,
  GetEditorialChildLocationSearchResultsData,
  GetEditorialChildLocationSearchResultsErrors,
  GetEditorialChildLocationSearchResultsResponses,
  GetEditorialChildLocationsErrors,
  GetEditorialChildLocationsResponses,
  GetEditorialConfigurationData,
  GetEditorialConfigurationErrors,
  GetEditorialConfigurationResponses,
  GetEditorialLocationBuildersData,
  GetEditorialLocationBuildersErrors,
  GetEditorialLocationBuildersResponses,
  GetEditorialLocationData,
  GetEditorialLocationErrors,
  GetEditorialLocationNearbySearchResultsData,
  GetEditorialLocationNearbySearchResultsErrors,
  GetEditorialLocationNearbySearchResultsResponses,
  GetEditorialLocationResponses,
  GetEditorialLocationsData,
  GetEditorialLocationSearchResultsData,
  GetEditorialLocationSearchResultsErrors,
  GetEditorialLocationSearchResultsResponses,
  GetEditorialLocationsErrors,
  GetEditorialLocationsResponses,
  GetExploreData,
  GetExploreErrors,
  GetExploreResponses,
  GetFeaturedProjectsData,
  GetFeaturedProjectsErrors,
  GetFeaturedProjectsResponses,
  GetHomeHeroImagesData,
  GetHomeHeroImagesErrors,
  GetHomeHeroImagesResponses,
  GetHomeQuickLinksData,
  GetHomeQuickLinksErrors,
  GetHomeQuickLinksResponses,
  GetNearbyProjectsData,
  GetNearbyProjectsErrors,
  GetNearbyProjectsResponses,
  GetNearbySearchResultsData,
  GetNearbySearchResultsErrors,
  GetNearbySearchResultsResponses,
  GetNewListingAlertLocationNameData,
  GetNewListingAlertLocationNameErrors,
  GetNewListingAlertLocationNameResponses,
  GetNewProjectsData,
  GetNewProjectsErrors,
  GetNewProjectsResponses,
  GetPresentationConfigurationData,
  GetPresentationConfigurationErrors,
  GetPresentationConfigurationResponses,
  GetProfileSubscriptionsData,
  GetProfileSubscriptionsErrors,
  GetProfileSubscriptionsResponses,
  GetProjectArticlesData,
  GetProjectArticlesErrors,
  GetProjectArticlesResponses,
  GetProjectCardData,
  GetProjectCardErrors,
  GetProjectCardResponses,
  GetProjectDetailsData,
  GetProjectDetailsErrors,
  GetProjectDetailsResponses,
  GetProvincesData,
  GetProvincesErrors,
  GetProvincesResponses,
  GetRegionData,
  GetRegionErrors,
  GetRegionResponses,
  GetRegionsData,
  GetRegionsErrors,
  GetRegionsResponses,
  GetSearchAutocompleteData,
  GetSearchAutocompleteErrors,
  GetSearchAutocompleteResponses,
  GetSearchFiltersData,
  GetSearchFiltersErrors,
  GetSearchFiltersResponses,
  GetSearchResultsData,
  GetSearchResultsErrors,
  GetSearchResultsResponses,
  GetStatusData,
  GetStatusErrors,
  GetStatusResponses,
  ProfileLoginData,
  ProfileLoginErrors,
  ProfileLoginResponses,
  RegisterAdUnitClickData,
  RegisterAdUnitClickErrors,
  RegisterAdUnitClickResponses,
  SendEditorialLeadData,
  SendEditorialLeadErrors,
  SendEditorialLeadResponses,
  SendMessageData,
  SendMessageErrors,
  SendMessageResponses,
  StreamProjectConversationData,
  StreamProjectConversationErrors,
  StreamProjectConversationResponse,
  StreamProjectConversationResponses,
  TrackData,
  TrackErrors,
  TrackResponses,
  UnsubscribeAllSubscriptionsData,
  UnsubscribeAllSubscriptionsErrors,
  UnsubscribeAllSubscriptionsResponses,
  UpdateNewListingAlertSubscriptionData,
  UpdateNewListingAlertSubscriptionErrors,
  UpdateNewListingAlertSubscriptionResponses,
  UpdateNewsletterSubscriptionData,
  UpdateNewsletterSubscriptionErrors,
  UpdateNewsletterSubscriptionResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getAdUnitToDisplay = <ThrowOnError extends boolean = false>(options: Options<GetAdUnitToDisplayData, ThrowOnError>): RequestResult<GetAdUnitToDisplayResponses, GetAdUnitToDisplayErrors, ThrowOnError> =>
  (options.client ?? client).get<GetAdUnitToDisplayResponses, GetAdUnitToDisplayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ad-unit',
    ...options,
  });

export const getAdUnit = <ThrowOnError extends boolean = false>(options: Options<GetAdUnitData, ThrowOnError>): RequestResult<GetAdUnitResponses, GetAdUnitErrors, ThrowOnError> =>
  (options.client ?? client).get<GetAdUnitResponses, GetAdUnitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ad-unit/{adUnitId}',
    ...options,
  });

export const registerAdUnitClick = <ThrowOnError extends boolean = false>(options: Options<RegisterAdUnitClickData, ThrowOnError>): RequestResult<RegisterAdUnitClickResponses, RegisterAdUnitClickErrors, ThrowOnError> =>
  (options.client ?? client).post<RegisterAdUnitClickResponses, RegisterAdUnitClickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ad-unit/{adUnitId}',
    ...options,
  });

export const getArticleAuthor = <ThrowOnError extends boolean = false>(options: Options<GetArticleAuthorData, ThrowOnError>): RequestResult<GetArticleAuthorResponses, GetArticleAuthorErrors, ThrowOnError> =>
  (options.client ?? client).get<GetArticleAuthorResponses, GetArticleAuthorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/article-authors/{articleAuthorSlug}',
    ...options,
  });

export const getArticleCategory = <ThrowOnError extends boolean = false>(options: Options<GetArticleCategoryData, ThrowOnError>): RequestResult<GetArticleCategoryResponses, GetArticleCategoryErrors, ThrowOnError> =>
  (options.client ?? client).get<GetArticleCategoryResponses, GetArticleCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/article-categories/{articleCategorySlug}',
    ...options,
  });

export const getArticles = <ThrowOnError extends boolean = false>(options?: Options<GetArticlesData, ThrowOnError>): RequestResult<GetArticlesResponses, GetArticlesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetArticlesResponses, GetArticlesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/articles',
    ...options,
  });

export const getArticle = <ThrowOnError extends boolean = false>(options: Options<GetArticleData, ThrowOnError>): RequestResult<GetArticleResponses, GetArticleErrors, ThrowOnError> =>
  (options.client ?? client).get<GetArticleResponses, GetArticleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/articles/{articleId}',
    ...options,
  });

export const getEditorialArticles = <ThrowOnError extends boolean = false>(options: Options<GetEditorialArticlesData, ThrowOnError>): RequestResult<GetEditorialArticlesResponses, GetEditorialArticlesErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialArticlesResponses, GetEditorialArticlesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/articles/editorial',
    ...options,
  });

export const getBuilders = <ThrowOnError extends boolean = false>(options?: Options<GetBuildersData, ThrowOnError>): RequestResult<GetBuildersResponses, GetBuildersErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetBuildersResponses, GetBuildersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/builders',
    ...options,
  });

export const getBuilder = <ThrowOnError extends boolean = false>(options: Options<GetBuilderData, ThrowOnError>): RequestResult<GetBuilderResponses, GetBuilderErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBuilderResponses, GetBuilderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/builders/{builderId}',
    ...options,
  });

export const getBuilderArticles = <ThrowOnError extends boolean = false>(options: Options<GetBuilderArticlesData, ThrowOnError>): RequestResult<GetBuilderArticlesResponses, GetBuilderArticlesErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBuilderArticlesResponses, GetBuilderArticlesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/builders/{builderId}/articles',
    ...options,
  });

export const getBuilderProjects = <ThrowOnError extends boolean = false>(options: Options<GetBuilderProjectsData, ThrowOnError>): RequestResult<GetBuilderProjectsResponses, GetBuilderProjectsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBuilderProjectsResponses, GetBuilderProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/builders/{builderId}/projects',
    ...options,
  });

export const getCities = <ThrowOnError extends boolean = false>(options: Options<GetCitiesData, ThrowOnError>): RequestResult<GetCitiesResponses, GetCitiesErrors, ThrowOnError> =>
  (options.client ?? client).get<GetCitiesResponses, GetCitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cities',
    ...options,
  });

export const getCity = <ThrowOnError extends boolean = false>(options: Options<GetCityData, ThrowOnError>): RequestResult<GetCityResponses, GetCityErrors, ThrowOnError> =>
  (options.client ?? client).get<GetCityResponses, GetCityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cities/{cityId}',
    ...options,
  });

export const getCustomIcons = <ThrowOnError extends boolean = false>(options?: Options<GetCustomIconsData, ThrowOnError>): RequestResult<GetCustomIconsResponses, GetCustomIconsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCustomIconsResponses, GetCustomIconsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/custom-icons',
    ...options,
  });

export const getDirectoryCategories = <ThrowOnError extends boolean = false>(options?: Options<GetDirectoryCategoriesData, ThrowOnError>): RequestResult<GetDirectoryCategoriesResponses, GetDirectoryCategoriesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetDirectoryCategoriesResponses, GetDirectoryCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directory-categories',
    ...options,
  });

export const sendEditorialLead = <ThrowOnError extends boolean = false>(options: Options<SendEditorialLeadData, ThrowOnError>): RequestResult<SendEditorialLeadResponses, SendEditorialLeadErrors, ThrowOnError> =>
  (options.client ?? client).post<SendEditorialLeadResponses, SendEditorialLeadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial-lead',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getEditorialBuilderLocations = <ThrowOnError extends boolean = false>(
  options?: Options<GetEditorialBuilderLocationsData, ThrowOnError>
): RequestResult<GetEditorialBuilderLocationsResponses, GetEditorialBuilderLocationsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetEditorialBuilderLocationsResponses, GetEditorialBuilderLocationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/builders',
    ...options,
  });

export const getEditorialCategories = <ThrowOnError extends boolean = false>(options?: Options<GetEditorialCategoriesData, ThrowOnError>): RequestResult<GetEditorialCategoriesResponses, GetEditorialCategoriesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetEditorialCategoriesResponses, GetEditorialCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories',
    ...options,
  });

export const getEditorialCategory = <ThrowOnError extends boolean = false>(options: Options<GetEditorialCategoryData, ThrowOnError>): RequestResult<GetEditorialCategoryResponses, GetEditorialCategoryErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialCategoryResponses, GetEditorialCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}',
    ...options,
  });

export const getAlternateCategorySlug = <ThrowOnError extends boolean = false>(options: Options<GetAlternateCategorySlugData, ThrowOnError>): RequestResult<GetAlternateCategorySlugResponses, GetAlternateCategorySlugErrors, ThrowOnError> =>
  (options.client ?? client).get<GetAlternateCategorySlugResponses, GetAlternateCategorySlugErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/alternate',
    ...options,
  });

export const getEditorialLocations = <ThrowOnError extends boolean = false>(options: Options<GetEditorialLocationsData, ThrowOnError>): RequestResult<GetEditorialLocationsResponses, GetEditorialLocationsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialLocationsResponses, GetEditorialLocationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations',
    ...options,
  });

export const getEditorialLocation = <ThrowOnError extends boolean = false>(options: Options<GetEditorialLocationData, ThrowOnError>): RequestResult<GetEditorialLocationResponses, GetEditorialLocationErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialLocationResponses, GetEditorialLocationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{editorialLocationSlug}',
    ...options,
  });

export const getAlternateLocationSlug = <ThrowOnError extends boolean = false>(options: Options<GetAlternateLocationSlugData, ThrowOnError>): RequestResult<GetAlternateLocationSlugResponses, GetAlternateLocationSlugErrors, ThrowOnError> =>
  (options.client ?? client).get<GetAlternateLocationSlugResponses, GetAlternateLocationSlugErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{editorialLocationSlug}/alternate',
    ...options,
  });

export const getEditorialLocationBuilders = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialLocationBuildersData, ThrowOnError>
): RequestResult<GetEditorialLocationBuildersResponses, GetEditorialLocationBuildersErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialLocationBuildersResponses, GetEditorialLocationBuildersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{editorialLocationSlug}/builders',
    ...options,
  });

export const getEditorialChildLocations = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialChildLocationsData, ThrowOnError>
): RequestResult<GetEditorialChildLocationsResponses, GetEditorialChildLocationsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialChildLocationsResponses, GetEditorialChildLocationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{editorialLocationSlug}/locations',
    ...options,
  });

export const getEditorialLocationSearchResults = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialLocationSearchResultsData, ThrowOnError>
): RequestResult<GetEditorialLocationSearchResultsResponses, GetEditorialLocationSearchResultsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialLocationSearchResultsResponses, GetEditorialLocationSearchResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{editorialLocationSlug}/projects',
    ...options,
  });

export const getEditorialLocationNearbySearchResults = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialLocationNearbySearchResultsData, ThrowOnError>
): RequestResult<GetEditorialLocationNearbySearchResultsResponses, GetEditorialLocationNearbySearchResultsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialLocationNearbySearchResultsResponses, GetEditorialLocationNearbySearchResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{editorialLocationSlug}/projects/nearby',
    ...options,
  });

export const getEditorialChildLocation = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialChildLocationData, ThrowOnError>
): RequestResult<GetEditorialChildLocationResponses, GetEditorialChildLocationErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialChildLocationResponses, GetEditorialChildLocationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{parentEditorialLocationSlug}/locations/{editorialLocationSlug}',
    ...options,
  });

export const getAlternateChildLocationSlug = <ThrowOnError extends boolean = false>(
  options: Options<GetAlternateChildLocationSlugData, ThrowOnError>
): RequestResult<GetAlternateChildLocationSlugResponses, GetAlternateChildLocationSlugErrors, ThrowOnError> =>
  (options.client ?? client).get<GetAlternateChildLocationSlugResponses, GetAlternateChildLocationSlugErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{parentEditorialLocationSlug}/locations/{editorialLocationSlug}/alternate',
    ...options,
  });

export const getEditorialChildLocationSearchResults = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialChildLocationSearchResultsData, ThrowOnError>
): RequestResult<GetEditorialChildLocationSearchResultsResponses, GetEditorialChildLocationSearchResultsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialChildLocationSearchResultsResponses, GetEditorialChildLocationSearchResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{parentEditorialLocationSlug}/locations/{editorialLocationSlug}/projects',
    ...options,
  });

export const getEditorialChildLocationNearbySearchResults = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialChildLocationNearbySearchResultsData, ThrowOnError>
): RequestResult<GetEditorialChildLocationNearbySearchResultsResponses, GetEditorialChildLocationNearbySearchResultsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialChildLocationNearbySearchResultsResponses, GetEditorialChildLocationNearbySearchResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/locations/{parentEditorialLocationSlug}/locations/{editorialLocationSlug}/projects/nearby',
    ...options,
  });

export const getEditorialCategorySearchResults = <ThrowOnError extends boolean = false>(
  options: Options<GetEditorialCategorySearchResultsData, ThrowOnError>
): RequestResult<GetEditorialCategorySearchResultsResponses, GetEditorialCategorySearchResultsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEditorialCategorySearchResultsResponses, GetEditorialCategorySearchResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/categories/{editorialCategorySlug}/projects',
    ...options,
  });

export const getEditorialConfiguration = <ThrowOnError extends boolean = false>(
  options?: Options<GetEditorialConfigurationData, ThrowOnError>
): RequestResult<GetEditorialConfigurationResponses, GetEditorialConfigurationErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetEditorialConfigurationResponses, GetEditorialConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/editorial/configuration',
    ...options,
  });

export const getExplore = <ThrowOnError extends boolean = false>(options?: Options<GetExploreData, ThrowOnError>): RequestResult<GetExploreResponses, GetExploreErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetExploreResponses, GetExploreErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/explore',
    ...options,
  });

export const sendMessage = <ThrowOnError extends boolean = false>(options: Options<SendMessageData, ThrowOnError>): RequestResult<SendMessageResponses, SendMessageErrors, ThrowOnError> =>
  (options.client ?? client).post<SendMessageResponses, SendMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getPresentationConfiguration = <ThrowOnError extends boolean = false>(
  options?: Options<GetPresentationConfigurationData, ThrowOnError>
): RequestResult<GetPresentationConfigurationResponses, GetPresentationConfigurationErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPresentationConfigurationResponses, GetPresentationConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/presentation/configuration',
    ...options,
  });

export const getHomeHeroImages = <ThrowOnError extends boolean = false>(options?: Options<GetHomeHeroImagesData, ThrowOnError>): RequestResult<GetHomeHeroImagesResponses, GetHomeHeroImagesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetHomeHeroImagesResponses, GetHomeHeroImagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/presentation/home/hero-images',
    ...options,
  });

export const getHomeQuickLinks = <ThrowOnError extends boolean = false>(options?: Options<GetHomeQuickLinksData, ThrowOnError>): RequestResult<GetHomeQuickLinksResponses, GetHomeQuickLinksErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetHomeQuickLinksResponses, GetHomeQuickLinksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/presentation/home/quick-links',
    ...options,
  });

export const profileLogin = <ThrowOnError extends boolean = false>(options?: Options<ProfileLoginData, ThrowOnError>): RequestResult<ProfileLoginResponses, ProfileLoginErrors, ThrowOnError> =>
  (options?.client ?? client).get<ProfileLoginResponses, ProfileLoginErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/login',
    ...options,
  });

export const getProfileSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<GetProfileSubscriptionsData, ThrowOnError>): RequestResult<GetProfileSubscriptionsResponses, GetProfileSubscriptionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetProfileSubscriptionsResponses, GetProfileSubscriptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/subscriptions',
    ...options,
  });

export const createNewListingAlertSubscription = <ThrowOnError extends boolean = false>(
  options: Options<CreateNewListingAlertSubscriptionData, ThrowOnError>
): RequestResult<CreateNewListingAlertSubscriptionResponses, CreateNewListingAlertSubscriptionErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateNewListingAlertSubscriptionResponses, CreateNewListingAlertSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/subscriptions/new-listing-alerts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteNewListingAlertSubscription = <ThrowOnError extends boolean = false>(
  options: Options<DeleteNewListingAlertSubscriptionData, ThrowOnError>
): RequestResult<DeleteNewListingAlertSubscriptionResponses, DeleteNewListingAlertSubscriptionErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteNewListingAlertSubscriptionResponses, DeleteNewListingAlertSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/subscriptions/new-listing-alerts/{subscriptionId}',
    ...options,
  });

export const updateNewListingAlertSubscription = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNewListingAlertSubscriptionData, ThrowOnError>
): RequestResult<UpdateNewListingAlertSubscriptionResponses, UpdateNewListingAlertSubscriptionErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateNewListingAlertSubscriptionResponses, UpdateNewListingAlertSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/subscriptions/new-listing-alerts/{subscriptionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getNewListingAlertLocationName = <ThrowOnError extends boolean = false>(
  options: Options<GetNewListingAlertLocationNameData, ThrowOnError>
): RequestResult<GetNewListingAlertLocationNameResponses, GetNewListingAlertLocationNameErrors, ThrowOnError> =>
  (options.client ?? client).get<GetNewListingAlertLocationNameResponses, GetNewListingAlertLocationNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/subscriptions/new-listing-alerts/location-name',
    ...options,
  });

export const updateNewsletterSubscription = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNewsletterSubscriptionData, ThrowOnError>
): RequestResult<UpdateNewsletterSubscriptionResponses, UpdateNewsletterSubscriptionErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateNewsletterSubscriptionResponses, UpdateNewsletterSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/subscriptions/newsletters',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const unsubscribeAllSubscriptions = <ThrowOnError extends boolean = false>(
  options?: Options<UnsubscribeAllSubscriptionsData, ThrowOnError>
): RequestResult<UnsubscribeAllSubscriptionsResponses, UnsubscribeAllSubscriptionsErrors, ThrowOnError> =>
  (options?.client ?? client).post<UnsubscribeAllSubscriptionsResponses, UnsubscribeAllSubscriptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/profile/subscriptions/unsubscribe-all',
    ...options,
  });

export const getProjectCard = <ThrowOnError extends boolean = false>(options: Options<GetProjectCardData, ThrowOnError>): RequestResult<GetProjectCardResponses, GetProjectCardErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectCardResponses, GetProjectCardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}',
    ...options,
  });

export const getProjectArticles = <ThrowOnError extends boolean = false>(options: Options<GetProjectArticlesData, ThrowOnError>): RequestResult<GetProjectArticlesResponses, GetProjectArticlesErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectArticlesResponses, GetProjectArticlesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/articles',
    ...options,
  });

export const streamProjectConversation = <ThrowOnError extends boolean = false>(
  options: Options<StreamProjectConversationData, ThrowOnError, StreamProjectConversationResponse>
): Promise<ServerSentEventsResult<StreamProjectConversationResponses>> =>
  (options.client ?? client).sse.post<StreamProjectConversationResponses, StreamProjectConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/conversations/stream',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getProjectDetails = <ThrowOnError extends boolean = false>(options: Options<GetProjectDetailsData, ThrowOnError>): RequestResult<GetProjectDetailsResponses, GetProjectDetailsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectDetailsResponses, GetProjectDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/details',
    ...options,
  });

export const getNearbyProjects = <ThrowOnError extends boolean = false>(options: Options<GetNearbyProjectsData, ThrowOnError>): RequestResult<GetNearbyProjectsResponses, GetNearbyProjectsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetNearbyProjectsResponses, GetNearbyProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/nearby',
    ...options,
  });

export const getFeaturedProjects = <ThrowOnError extends boolean = false>(options?: Options<GetFeaturedProjectsData, ThrowOnError>): RequestResult<GetFeaturedProjectsResponses, GetFeaturedProjectsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetFeaturedProjectsResponses, GetFeaturedProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/featured',
    ...options,
  });

export const getNewProjects = <ThrowOnError extends boolean = false>(options?: Options<GetNewProjectsData, ThrowOnError>): RequestResult<GetNewProjectsResponses, GetNewProjectsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetNewProjectsResponses, GetNewProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/new',
    ...options,
  });

export const getProvinces = <ThrowOnError extends boolean = false>(options?: Options<GetProvincesData, ThrowOnError>): RequestResult<GetProvincesResponses, GetProvincesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetProvincesResponses, GetProvincesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/provinces',
    ...options,
  });

export const getRegions = <ThrowOnError extends boolean = false>(options: Options<GetRegionsData, ThrowOnError>): RequestResult<GetRegionsResponses, GetRegionsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetRegionsResponses, GetRegionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/regions',
    ...options,
  });

export const getRegion = <ThrowOnError extends boolean = false>(options: Options<GetRegionData, ThrowOnError>): RequestResult<GetRegionResponses, GetRegionErrors, ThrowOnError> =>
  (options.client ?? client).get<GetRegionResponses, GetRegionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/regions/{regionId}',
    ...options,
  });

export const getSearchResults = <ThrowOnError extends boolean = false>(options?: Options<GetSearchResultsData, ThrowOnError>): RequestResult<GetSearchResultsResponses, GetSearchResultsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSearchResultsResponses, GetSearchResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/search',
    ...options,
  });

export const getSearchAutocomplete = <ThrowOnError extends boolean = false>(options: Options<GetSearchAutocompleteData, ThrowOnError>): RequestResult<GetSearchAutocompleteResponses, GetSearchAutocompleteErrors, ThrowOnError> =>
  (options.client ?? client).get<GetSearchAutocompleteResponses, GetSearchAutocompleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/search/autocomplete',
    ...options,
  });

export const getSearchFilters = <ThrowOnError extends boolean = false>(options?: Options<GetSearchFiltersData, ThrowOnError>): RequestResult<GetSearchFiltersResponses, GetSearchFiltersErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSearchFiltersResponses, GetSearchFiltersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/search/filters',
    ...options,
  });

export const getNearbySearchResults = <ThrowOnError extends boolean = false>(options?: Options<GetNearbySearchResultsData, ThrowOnError>): RequestResult<GetNearbySearchResultsResponses, GetNearbySearchResultsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetNearbySearchResultsResponses, GetNearbySearchResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/search/nearby',
    ...options,
  });

/**
 * Gets the current status of the application.
 */
export const getStatus = <ThrowOnError extends boolean = false>(options?: Options<GetStatusData, ThrowOnError>): RequestResult<GetStatusResponses, GetStatusErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetStatusResponses, GetStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/status',
    ...options,
  });

export const createSubscription = <ThrowOnError extends boolean = false>(options: Options<CreateSubscriptionData, ThrowOnError>): RequestResult<CreateSubscriptionResponses, CreateSubscriptionErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateSubscriptionResponses, CreateSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/subscribe',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const track = <ThrowOnError extends boolean = false>(options: Options<TrackData, ThrowOnError>): RequestResult<TrackResponses, TrackErrors, ThrowOnError> =>
  (options.client ?? client).post<TrackResponses, TrackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/track',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
